import React from 'react';
import { MapFilterChip } from '../../services/api';
import { FilterChip } from '../../design-system/components';

interface MapFilterBarProps {
  chips: MapFilterChip[];
  activeIds: Set<number>;
  onToggle: (id: number) => void;
  onReset: () => void;
  className?: string;
}

/** Existing admin presets filter the list, not the map markers. Keep that scope visible. */
export const MapFilterBar: React.FC<MapFilterBarProps> = ({ chips, activeIds, onToggle, onReset, className = '' }) => {
  if (!chips.length) return null;
  const count = chips.filter((chip) => activeIds.has(chip.id)).length;
  const touchClass = 'min-h-[44px] text-[13px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink';
  return (
    <div className={className}>
      <div className="flex items-center gap-2 overflow-x-auto px-3.5 py-2 scrollbar-hide" role="group" aria-label="단지 목록 필터">
        <span className="shrink-0 rounded-ca-md bg-frame/95 px-2 py-1 text-[12px] font-semibold text-body" aria-live="polite">
          목록 조건{count > 0 ? ` ${count}개` : ''}
        </span>
        <FilterChip label={count > 0 ? '초기화' : '전체 목록'} active={count === 0} onClick={onReset} className={touchClass} />
        {chips.map((chip) => (
          <FilterChip key={chip.id} label={chip.label} active={activeIds.has(chip.id)} emphasis={chip.emphasis}
            onClick={() => onToggle(chip.id)} className={touchClass} />
        ))}
      </div>
    </div>
  );
};
